import { PlanType } from '../types/api';

// Supported plan types for API validation
export const VALID_PLAN_TYPES: PlanType[] = ['standard', 'premium'];

// localStorage key for promotion code
export const PROMO_CODE_STORAGE_KEY = 'piika_promo_code'; 